import supabase from '../supabase/supabase';

const STAYS = 'guest_house_stays_2100000000000';
const PLATFORMS = 'guest_house_platforms_2100000000000';

export async function availableRoomNumbers(checkIn, checkOut) {
  if (!checkIn || !checkOut || checkOut <= checkIn) return [];
  const { data, error } = await supabase.rpc('guest_house_available_rooms_2100000000000', {
    requested_check_in: checkIn,
    requested_check_out: checkOut
  });
  if (error) throw error;
  return (data || []).map((row) => row.room_number);
}

export async function listStays() {
  const { data, error } = await supabase.from(STAYS).select('*').order('check_in', { ascending: true });
  if (error) throw error;
  return data || [];
}

export async function addStay(values) {
  const { error } = await supabase.from(STAYS).insert(values);
  if (error) {
    if (error.code === '23P01') throw new Error('This room is already occupied during those dates.');
    throw error;
  }
}

export async function removeStay(id) {
  const { error } = await supabase.from(STAYS).delete().eq('id', id);
  if (error) throw error;
}

export async function listPlatforms() {
  const { data, error } = await supabase.from(PLATFORMS).select('name').order('name');
  if (error) throw error;
  return data || [];
}

export async function addPlatform(name) {
  const { error } = await supabase.from(PLATFORMS).insert({ name: name.trim() });
  if (error) throw error;
}